const JsBarcode = require("jsbarcode");
let canShowSign = true;
import { getLodop } from "./LodopFuncs";
import config from "../config/index";
const timeUtil = require("@/libs/timeUtil");
// import * as timeUtil from "../libs/timeUtil";

export function getPrintDevices() {
	let operateSys = detectOS();
	if (operateSys == "Mac" || operateSys == "Linux" || operateSys == "Unix") {
		alert("当前操作系统不支持LODOP打印");
		return;
	}
	let LODOP = getLodop(document.getElementById("LODOP_OB"), document.getElementById("LODOP_EM"));
	signWithLodop(LODOP);
	LODOP.PRINT_INIT("getPrintDevice");
	let deviceCount = LODOP.GET_PRINTER_COUNT();
	let printNameArr = [];
	// let deviceInfo = LODOP.READ_PORT_DATA("COM1");
	// console.log(deviceInfo);
	for (let index = 0; index < Number(deviceCount); index++) {
		let deviceName = LODOP.GET_PRINTER_NAME(index);
		let port = LODOP.GET_PRINTER_NAME(index + ":PortName");
		// let portInfo = LODOP.READ_PORT_DATA(port);
		// let driver = LODOP.GET_PRINTER_NAME(index+":DriverName");
		// console.log(deviceName, "设备号\n", port, "端口\n");
		printNameArr.push({ key: index, value: deviceName, port: port });
	}
	return printNameArr;
}

// 打印模板数据解析--第二版
// 打印模板数据构建
export function printByTemplate(taskId, printCount, deviceIndex, data, template, printType) {
	data.nowDate = timeUtil.getDate();
	let printTemplate = template.printTemplate;
	let isReceipts = false;
	let receiptsArr = [1, 5, 9];
	if (receiptsArr.includes(template.type)) {
		isReceipts = true;
	}
	// 判断是否是原始数据
	if (!printTemplate || !printTemplate.length) {
		return;
	} else {
		if (!printTemplate[0].childBox) {
			printTemplate = [
				{
					id: "test001",
					title: "内容区",
					boxType: "free",
					height: 0,
					childBox: JSON.parse(JSON.stringify(printTemplate))
				}
			];
		}
	}

	// 创建body
	let bodyHtml = createDiv();
	if (printTemplate.length) {
		printTemplate.forEach(item => {
			if (item.childBox && item.childBox.length) {
				// 创建内容区
				let div = createDiv();
				div.style.position = "relative";
				let hadTableNotOnLast = true;
				if (item.boxType == "free") {
					hadTableNotOnLast = false;
					for (let index = 0; index < item.childBox.length; index++) {
						let template = item.childBox[index];
						let lastIndex = item.childBox.length - 1;
						if ("atable" == template.type && index != lastIndex) {
							hadTableNotOnLast = true;
						}
					}
					if (!hadTableNotOnLast && !isReceipts) {
						div.style.height = item.height + "px";
					}
				}
				// 创建子元素
				item.childBox.forEach(template => {
					if ("atext" == template.type) {
						//设置文本信息
						let childTag = createText(template.data ? template.data : "", data, hadTableNotOnLast);
						if (childTag) {
							div.appendChild(childTag);
						}
					} else if ("atable" == template.type) {
						let childTag = createTable(template, data.tableData, hadTableNotOnLast);
						div.appendChild(childTag);
					} else if ("alist" == template.type) {
						let childTag = createList(template, data.listData);
						div.appendChild(childTag);
					} else if ("aimage" == template.type) {
						let childTag = createImage(template.data ? template.data : "", data, hadTableNotOnLast);
						div.appendChild(childTag);
					}
				});
				// 添加内容区元素
				bodyHtml.appendChild(div);
			}
		});
	}
	// return bodyHtml
	if (printType == 1) {
		//浏览器预览
		printHtml(bodyHtml);
	} else {
		let operateSys = detectOS();
		if (operateSys == "Mac" || operateSys == "Linux" || operateSys == "Unix") {
			if (canShowSign) {
				alert("当前操作系统不支持LODOP打印");
				canShowSign = false;
				setTimeout(() => {
					canShowSign = true;
				}, 2000);
			}
			return;
		}
		// 直接打印
		let page = template.page;
		let width = page.width;
		let height = page.height;
		let LODOP = getLodop(document.getElementById("LODOP_OB"), document.getElementById("LODOP_EM"));
		signWithLodop(LODOP);
		LODOP.PRINT_INIT(taskId + "");
		LODOP.SET_PRINT_COPIES(printCount);
		LODOP.SET_PRINT_PAGESIZE(page.intOrient, width + "px", height + "px", "LodopCustomPage");
		if (deviceIndex != null) {
			LODOP.SET_PRINTER_INDEX(deviceIndex);
		}
		LODOP.ADD_PRINT_HTM("5px", "0px", "100%", "100%", bodyHtml.outerHTML);
		LODOP.PRINT();
	}
}

/**
 * 模板打印功能
 * @author gjp
 * @date 2022-02-16
 * @param {Object} template 打印模板
 * @param {Array} printData 打印数据
 * @param {Number} deviceIndex 打印设备索引
 * @param {Number} temp 1预览 2打印
 */
export function printByTemplateV2(template, printData, deviceIndex, type) {
	let temp = lwDeepClone(template);
	let data = lwDeepClone(printData);

	//测试预览
	// type = 1;

	// 模版和数据生成html
	let html = tempToHtml(temp, data, type);

	console.log("html", html);

	if (type == 1) {
		// 预览
		setTimeout(() => {
			// 打开新窗口
			let newWindow = window.open("");
			// 写入打印内容
			newWindow.document.write(html.outerHTML);
			setTimeout(() => {
				// 设置标题
				newWindow.document.title = temp.title;
				// 关闭文档编写
				newWindow.document.close();
				// 新窗口聚集焦点
				newWindow.focus();
				// 打印事件
				newWindow.print();
			}, 10);
		}, 10);
	} else {
		// 打印
		let operateSys = detectOS();
		if (operateSys == "Mac" || operateSys == "Linux" || operateSys == "Unix") {
			if (canShowSign) {
				alert("当前操作系统不支持LODOP打印");
				canShowSign = false;
				setTimeout(() => {
					canShowSign = true;
				}, 2000);
			}
			return;
		}
		// 直接打印
		let page = temp.page;
		let width = temp.width;
		let height = temp.height;
		let LODOP = getLodop(document.getElementById("LODOP_OB"), document.getElementById("LODOP_EM"));
		signWithLodop(LODOP);
		LODOP.PRINT_INIT("sorting");
		LODOP.SET_PRINT_COPIES(1);

		// if (temp.printType && temp.printType == 1) {
		//   LODOP.SET_PRINT_PAGESIZE(3, width + "px", "10px", "LodopCustomPage");
		// } else {
		//   LODOP.SET_PRINT_PAGESIZE(1, width + "px", height + "px", "LodopCustomPage");
		// }
		LODOP.SET_PRINT_PAGESIZE(3, width + "px", "10px", "LodopCustomPage");
		if (deviceIndex != null) {
			LODOP.SET_PRINTER_INDEX(deviceIndex);
		}

		LODOP.ADD_PRINT_HTM("5px", "0px", "100%", "100%", html.outerHTML);
		LODOP.PRINT();
	}

	// htmlToAst(html);
}

function printHtml(html) {
	let newWindow = window.open("");
	// 放置打印内容
	newWindow.document.write(html.outerHTML);
	// 关闭文档编写
	newWindow.document.close();
	// 新窗口聚集焦点
	newWindow.focus();
	// 打印事件
	newWindow.print();
}

/**
 * 当前运行环境
 * @author gjp
 * @date 2022-02-16
 * @returns 当前运行环境
 */
function detectOS() {
	var sUserAgent = navigator.userAgent;
	var isWin = navigator.platform == "Win32" || navigator.platform == "Windows";
	var isMac =
		navigator.platform == "Mac68K" ||
		navigator.platform == "MacPPC" ||
		navigator.platform == "Macintosh" ||
		navigator.platform == "MacIntel";
	if (isMac) return "Mac";
	var isUnix = navigator.platform == "X11" && !isWin && !isMac;
	if (isUnix) return "Unix";
	var isLinux = String(navigator.platform).indexOf("Linux") > -1;
	if (isLinux) return "Linux";
	if (isWin) {
		var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
		if (isWin2K) return "Win2000";
		var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
		if (isWinXP) return "WinXP";
		var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
		if (isWin2003) return "Win2003";
		var isWinVista = sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
		if (isWinVista) return "WinVista";
		var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
		if (isWin7) return "Win7";
		var isWin8 = sUserAgent.indexOf("Windows NT 8.0") > -1 || sUserAgent.indexOf("Windows 8") > -1;
		if (isWin8) return "Win8";
		var isWin10 = sUserAgent.indexOf("Windows NT 10.0") > -1 || sUserAgent.indexOf("Windows 10") > -1;
		if (isWin10) return "Win10";
	}
	return "other";
}

/**
 * 设置lodop签名配置
 * @author gjp
 * @date 2022-02-16
 * @param {*} lodop
 */
function signWithLodop(lodop) {
	lodop.SET_LICENSES("", config.lodop_code, "");
}

/**
 * 模版和数据生成html
 * @author gjp
 * @date 2022-02-16
 * @param {Object} temp 打印模版
 * @param {Array} data 模版数据
 * @returns {html} html
 */
function tempToHtml(temp, data, type) {
	// 创建html
	let html = document.createElement("div");
	html.style.width = temp.width + "px";
	// html.style.height = temp.height + "px";
	html.style.position = "absolute";
	html.setAttribute("min-height", temp.height + "px");

	// 解析模板和数据生成打印项
	let printContent = tempParser(temp.tempItems, data);
	// console.log("printContent", printContent);

	printContent[0].forEach(printItem => {
		// 添加打印项
		html = addPrintItem(html, printItem, type);
	});
	// console.log(html);
	return html;
}

/**
 * 解析模板和数据生成打印项
 * @author gjp
 * @date 2022-02-16
 * @param {Array} tempItem 模板打印项
 * @param {Array} data 打印数据,
 * @return {Array} 若data为null则返回处理后的模板
 */
function tempParser(tempItem, data) {
	let temp = [...tempItem];
	temp.sort(function(a, b) {
		return a.top - b.top;
	});
	//将自适应高度的打印项（item.style.AutoHeight == true）放在第一项
	let flag = temp.findIndex(item => item.style.AutoHeight);
	if (flag != -1) {
		let autoItem = temp[flag];
		// 处理位于自适应打印项下方的打印项
		temp.forEach(item => {
			// console.log(JSON.stringify(item));
			// 位于自适应高度项下的打印项修改top、left,并添加关联属性（style.LinkedItem）
			// if (item.top > autoItem.top && item.style.ItemType == 0) {
			if (item.top > autoItem.top) {
				item.top = item.top - autoItem.top - autoItem.height;
				item.left = item.left - autoItem.left;
				item.style.LinkedItem = 1;
			}
		});
	}

	if (data && data.length > 0) {
		// 解析打印模板和数据，生成生成打印内容
		let tempContent = [];
		data.forEach(dataItem => {
			let conItem = temp.map(tempItem => {
				let item = {
					...tempItem
				};
				if (item.name) {
					item.defaultValue = dataItem[item.name];
					item.value = strTempToValue(item.value, item.defaultValue);
				}
				return item;
			});
			tempContent.push(conItem);
		});
		return tempContent;
	} else {
		return [temp];
	}
}

/**
 * 添加打印项
 * @author gjp
 * @date 2022-02-16
 * @param {html} html
 * @param {Object} printItem 打印项内容
 * @param {Number} pageIndex 当前打印页的开始序号
 * @returns {html} html
 */
function addPrintItem(html, tempItem, type, pageIndex = 0) {
	let printItem = {
		...tempItem
	};
	// TempItemStyle转换为LodopItemStyle
	let lodopStyle = createLodopStyle(printItem.style);

	// 批量打印时，修改关联打印项的关联序号
	if (lodopStyle.LinkedItem == 1) {
		lodopStyle.LinkedItem = 1 + pageIndex;
	}
	// 添加打印项
	switch (printItem.type) {
		case "braid-txt":
			let braid_txt = textTempTohtml(printItem, type);
			html.appendChild(braid_txt);
			break;
		case "bar-code":
			if (printItem.value) {
				printItem.value = printItem.defaultValue;
				let bar_code = codeTempTohtml(printItem);
				html.appendChild(bar_code);
			}
			break;
		case "braid-html":
			break;
		case "braid-table":
			let braid_table = tableTempTohtml(printItem, lodopStyle);
			html.appendChild(braid_table);
			break;
		case "braid-image":
			let braid_image = imageTempTohtml(printItem);
			html.appendChild(braid_image);
			break;
		default:
			"";
	}
	return html;
}

/**
 * 将模板设计样式转换为lodop样式
 * @author gjp
 * @date 2022-02-16
 * @param {Object} style 模板样式
 * @returns {Object} lodopStyle lodop样式对象
 */
function createLodopStyle(style) {
	let lodopStyle = {
		zIndex: style.zIndex
	};

	for (let key in style) {
		if (["Bold", "Italic", "Underline", "ShowBarText"].indexOf(key) > -1) {
			lodopStyle[key] = style[key] ? 1 : 0;
		} else if (key === "Alignment") {
			lodopStyle[key] = style[key] == "left" ? 1 : style[key] == "center" ? 2 : 3;
		} else {
			lodopStyle[key] = style[key];
		}
	}
	return lodopStyle;
}

/**
 * 将字符串模板中{}内的内容替换成指定值
 * @author gjp
 * @date 2022-02-16
 * @param str 表格列配置信息
 * @param value 表格数据
 */
export const strTempToValue = (str, value) => {
	let reg = /({[^}^{]*})/g;
	return str.replace(reg, value || "");
};

/**
 * braid-txt类型的模板转换成html
 * @author gjp
 * @date 2022-02-16
 * @param {Object} template 打印数据
 * @returns {html} textDiv
 */
function textTempTohtml(template, type) {
	let textDiv = document.createElement("div");
	let styles = "";
	styles =
		"position: absolute;margin-top:" +
		template.top +
		"px;margin-left:" +
		template.left +
		"px;width:" +
		template.width +
		"px;height:" +
		template.height;
	let style = template.style;
	for (var key in style) {
		switch (key) {
			case "Alignment":
				styles += "text-align:" + style[key] + ";";
				break;
			case "Bold":
				if (style[key]) {
					styles += "font-weight:bold;";
				}
				break;
			case "FontColor":
				styles += "color:" + style[key] + ";";
				break;
			case "FontSize":
				styles += "font-size:" + parseInt(style[key]) + "px;";
				break;
			case "Italic":
				styles += "font-style:" + (style[key] ? "italic" : "normal") + ";";
				break;
			case "Underline":
				styles += "text-decoration:" + (style[key] ? "underline" : "none") + ";";
				break;
			case "zIndex":
				styles += "z-index:" + parseInt(style[key]) + ";";
				break;
			default:
		}
	}
	if (template.value.includes("========") || template.value.includes("--------")) {
		// 如果是分割线
		if (type == 1) {
			// 预览
			template.value = "-------------------------";
		} else {
			template.value = "---------------------------------------------";
		}
	}
	textDiv.innerHTML = template.value;
	textDiv.style = styles;
	return textDiv;
}

// /**
//  * braid-code类型的模板转换成html
//  * @author gjp
//  * @date 2022-02-16
//  * @param {Object} template 打印数据
//  * @returns {html} img
//  */
// function codeTempTohtml(template) {
//   let img = document.createElement("img");
//   if (template.value) {
//     JsBarcode(img, template.value, {
//       displayValue: false
//     });
//   }
//   let styles = "position: absolute;margin-top:" + template.top + "px;margin-left:" + template.left + "px;width:" + template.width + "px;height:" + template.height + "px;";
//   img.style = styles;
//   return img;
// }

/**
 * braid-code类型的模板转换成html
 * @author gjp
 * @date 2022-02-16
 * @param {Object} template 打印数据
 * @returns {html} img
 */
function codeTempTohtml(template) {
	let img = document.createElement("img");
	if (template.value) {
		let style = {
			displayValue: true, // 是否展示文字
			margin: 0,
			width: Number(((unitConversionToPoint(template.width) / 150) * 2).toFixed(2)),
			// height: template.height,
			height: unitConversionToPoint(template.height),
			// fontOptions: "bold"
			marginTop: -5
		};
		if (template.style.FontSize) {
			style.fontSize = template.style.FontSize;
		}
		JsBarcode(img, template.defaultValue, style);
	}
	// let styles = "position: absolute;margin-top:" + template.top + "px;margin-left:" + template.left + "px;width:" +
	// 	template.width + "px;height:" + template.height + "px;";
	let styles = "position: absolute;margin-top:" + template.top + "px;margin-left:" + template.left + "px;";
	img.style = styles;
	return img;
}

function unitConversionToPoint(data) {
	return Number((((data / 96) * 25.4 * 8) / 2).toFixed(0));
}

/**
 * braid-html类型的模板转换成html
 * @author gjp
 * @date 2022-02-16
 * @param {*} val html值
 * @param {*} style 样式
 * @returns
 */
function htmlTempTohtml(val, style) {
	// 表格全局样式
	let styleStr = "text-align:" + style.Alignment + ";";
	styleStr += "font-size:" + style.FontSize + "pt;";
	styleStr += "color:" + style.FontColor + ";";
	let html = "<span style='" + styleStr + "'>";
	html += val;
	html += "</span>";
	return html;
}

/**
 * braid-tabel类型的模板转换成html
 * @author gjp
 * @date 2022-02-16
 * @param {Object} template 打印数据
 * @param {Object} lodopStyle LODOP默认打印项样式
 * @returns {html} tableDiv
 */
function tableTempTohtml(template, lodopStyle) {
	let tableDiv = document.createElement("div");

	let columns = template.columns ? template.columns : []; // 表格列配置信息
	let data = template.defaultValue; // 表格数据
	let style = template.style; // 表格样式

	let width = "width=" + template.width; // 表格宽度
	let height = "min-height=" + template.height; // 表格高度
	// 表格全局样式
	var styleStr = "text-align:" + style.Alignment + ";"; // 对齐方式
	styleStr += "font-size:" + style.FontSize + "pt;"; // 字体大小
	styleStr += "color:" + style.FontColor + ";"; // 字体颜色
	styleStr += "margin-top:" + template.top + ";"; // 上边距
	styleStr += "margin-left:" + template.left + ";"; // 左边距
	if (lodopStyle.AutoHeight) {
		// styleStr += 'margin-bottom:' + lodopStyle.BottomMargin + 'mm;'; // 下边距
	}
	let borderStyle = "border:1px solid " + style.BorderColor;
	if (!style.borderWidth) {
		// false不展示边框(默认), true 展示边框
		borderStyle = "border: 0px none ";
		styleStr += "border: 0px none;";
	}
	var html = "<style> table td,table th {word-break: break-all;box-sizing:border-box; " + borderStyle + "}</style>";
	let tableHtml =
		"<table border=1 " +
		width +
		height +
		" cellspacing='0' frame=\"box\" cellpadding='2' style='border-collapse:collapse;" +
		styleStr +
		"' bordercolor='" +
		style.BorderColor +
		"'>"; // 解析表头
	if (!style.borderWidth) {
		// false不展示边框(默认), true 展示边框
		tableHtml = "<table " + width + height + " cellspacing='0' frame=\"box\" cellpadding='2' style='" + styleStr + "'>"; // 解析表头
	}
	html = html + tableHtml;

	html += "<thead><tr>";
	columns.forEach(function(column) {
		if (column.name === "_seq") {
			// 序号列
			html += '<th width="30">';
		} else {
			if (column.style) {
				let thStyle = "style='";
				for (var key in column.style) {
					switch (key) {
						case "Alignment":
							thStyle += "text-align:" + column.style[key] + ";";
							break;
						case "width":
							thStyle += "width:" + column.style[key] + ";";
							break;
						default:
					}
				}
				html += "<th " + thStyle + "'>";
			} else {
				html += "<th>";
			}
		}

		html += column.title;
		html += "</th>";
	});
	html += "</tr></thead>";
	html += "<tbody>"; // 解析内容

	if (Array.isArray(data)) {
		data.forEach(function(item, idx) {
			html += "<tr>";
			columns.forEach(function(column) {
				if (column.name === "_seq") {
					html += "<td>";
					html += idx + 1;
				} else {
					if (column.style) {
						let tdStyle = "style=";
						for (var key in column.style) {
							switch (key) {
								case "Alignment":
									tdStyle += "text-align:" + column.style[key] + ";";
									break;
								case "width":
									tdStyle += "width:" + column.style[key] + ";";
									break;
								default:
							}
						}
						tdStyle += "vertical-align:text-top";
						html += "<td " + tdStyle + ">";
					} else {
						html += "<td>";
					}
					html += item[column.name];
				}

				html += "</td>";
			});
			html += "</tr>";
		});
	}

	html += "</tbody>";
	html += "</table>";

	tableDiv.innerHTML = html;
	return tableDiv;
}

/**
 * braid-image类型的模板转换成html
 * @author gjp
 * @date 2022-02-16
 * @param template 打印数据
 */
function imageTempTohtml(template) {
	let img = document.createElement("img");
	let styles =
		"position: absolute;margin-top:" +
		template.top +
		"px;margin-left:" +
		template.left +
		"px;width:" +
		template.width +
		"px;height:" +
		template.height +
		"px;";
	img.src = template.value;
	img.style = styles;
	return img;
}

// 数据深拷贝
let lwDeepClone = function(value) {
	let t = lwTypeOf(value);
	let data;
	if (t === "object") {
		data = {};
	} else if (t === "array") {
		data = [];
	} else {
		return value;
	}

	if (t === "array") {
		for (let i = 0; i < value.length; i++) {
			data.push(lwDeepClone(value[i]));
		}
	} else if (t === "object") {
		for (let i in value) {
			data[i] = lwDeepClone(value[i]);
		}
	}
	return data;
};

// 判断数据类型
let lwTypeOf = function(value) {
	let toString = Object.prototype.toString;
	let map = {
		"[object Null]": "null",
		"[object Date]": "date",
		"[object Array]": "array",
		"[object Object]": "object",
		"[object String]": "string",
		"[object Number]": "number",
		"[object RegExp]": "regExp",
		"[object Boolean]": "boolean",
		"[object Function]": "function",
		"[object Undefined]": "undefined"
	};
	return map[toString.call(value)];
};

// 创建div
function createDiv() {
	return document.createElement("div");
}

// 创建文本
function createText(template, data, hadTableNotOnLast) {
	const databind = template.databind;
	const style = template.style;
	let text = "";
	if (typeof data[databind.id] != "object") {
		text = data[databind.id];
	} else if (databind.id == "tableData") {
		for (let index = 0; index < data[databind.id].length; index++) {
			let noteHead =
				data[databind.id][index].index + "-" + data[databind.id][index].product_name + "-" + data[databind.id][index].buyer + ":";
			let note = data[databind.id][index].order_note ? data[databind.id][index].order_note : "无备注";
			text += noteHead + note + "  ";
		}
	}
	if (template.isShowText == 3) {
		text = template.value;
	} else {
		if (!text) return null;
		if (template.isShowText == 1) {
			text = template.value + ":" + text;
		}
	}
	let textDiv = document.createElement("div");
	let styles = "";
	if (hadTableNotOnLast) {
		styles = "position: relative;left:" + template.x + "px;" + "width:" + template.width + "px;height:" + template.height + "px;";
	} else {
		styles = "position: absolute;top:" + template.y + "px;left:" + template.x + "px;";
	}
	for (var key in style) {
		switch (key) {
			case "color":
				styles += "color:" + style[key] + ";";
				break;
			case "fontFamily":
				styles += "font-family:" + style[key] + ";";
				break;
			case "fontSize":
				styles += "font-size:" + parseInt(style[key]) + "px;";
				break;
			case "fontSpacing":
				styles += "letter-spacing:" + parseInt(style[key]) + ";";
				break;
			case "fontWeight":
				styles += "font-weight:" + style[key] + ";";
				break;
			case "fontStyle":
				styles += "font-style:" + style[key] + ";";
				break;
			case "textAlign": {
				styles += "text-align:" + style[key] + ";";
				break;
			}
			default:
		}
	}
	textDiv.innerHTML = text;
	textDiv.style = styles;
	return textDiv;
}

// 创建图片
function createImage(template, data, hadTableNotOnLast) {
	let imgdata;
	let imgtype;
	if (template.databind.id && template.databind.id != "" && data[template.databind.id]) {
		imgtype = template.databindtype;
		imgdata = data[template.databind.id];
	} else {
		imgtype = template.style.defaultimgtype;
		imgdata = template.style.defaultimg;
	}
	if (imgtype == 1) {
		imgdata = "URL:" + imgdata;
	}

	let imgEl = document.createElement("img");
	let styles =
		"position: absolute;top:" +
		template.y +
		"px;left:" +
		template.x +
		"px;width:" +
		template.width +
		"px;height:" +
		template.height +
		"px;";
	if (hadTableNotOnLast) {
		styles =
			"position: relative;top:" +
			template.y +
			"px;left:" +
			template.x +
			"px;width:" +
			template.width +
			"px;height:" +
			template.height +
			"px;";
	}
	imgEl.src = imgdata;
	imgEl.style = styles;
	return imgEl;
}

// 创建列表
function createList(template, listData) {
	let listBox = createDiv();
	listData.forEach(item => {
		let listItem = createDiv();
		listItem.style.marginBottom = "20px";
		let merchantName = createDiv();
		merchantName.innerHTML = item[template.data.listTitle.databind.id];
		merchantName.style.width = "100%";
		merchantName.style.marginBottom = "10px";
		merchantName.style.color = template.data.listTitle.style.color;
		merchantName.style.fontSize = template.data.listTitle.style.fontSize;
		listItem.appendChild(merchantName);
		let table = createTable(template, item.tabledata, true);
		listItem.appendChild(table);
		listBox.appendChild(listItem);
	});
	return listBox;
}

// 创建表格
function createTable(template, tabledata, hadTableNotOnLast) {
	//表格头部
	template = template.data;
	let thead = template.thead;
	//表格行绑定
	let tbody = template.tbody;
	// 是否开启每页都有表头
	let everyPageHadHead = false;
	//创建表格
	let table = document.createElement("table");
	let tableThead = table;
	let tableTbody = table;
	if (everyPageHadHead) {
		tableThead = document.createElement("thead");
		tableThead.style.display = "table-header-group";
		tableTbody = document.createElement("tbody");
	}
	// 表格添加分页属性测试
	table.style.pageBreakInside = "auto";
	if (hadTableNotOnLast) {
		table.style.position = "relative";
		table.style.left = template.x + "px";
	} else {
		table.style.position = "absolute";
		table.style.top = template.y + "px";
		table.style.left = template.x + "px";
	}
	if (template.style.borderType > 0) {
		table.border = 1;
	}
	if (template.style.borderType == 2) {
		table.style.borderCollapse = "collapse";
	}
	let height = 0;
	//循环获得表头部
	for (var i = 0; i < thead.rows.length; i++) {
		var row = thead.rows[i];
		if (row["unprint"]) continue;
		var tr = tableThead.insertRow();
		tr.style.pageBreakInside = "avoid";
		tr.style.pageBreakAfter = "auto";

		for (var j = 0; j < row.cells.length; j++) {
			var cell = row.cells[j];
			var td = tr.insertCell();
			td.innerHTML = cell.value;
			td.style.width = cell.width + "px";
			td.style.height = cell.height + "px";
			for (var key in cell.style) {
				td.style[key] = cell.style[key];
			}
			if (i == 0) {
				height += cell.height;
			}
		}
	}
	//循环处理数据到表格
	if (table && tabledata.length) {
		for (var i = 0; i < tabledata.length; i++) {
			// 一行数据
			var ditem = tabledata[i];
			//获取表格的关联格式
			var row = tbody.rows[0];
			//初始化行
			var tr = tableTbody.insertRow();
			tr.style.pageBreakInside = "avoid";
			tr.style.pageBreakAfter = "auto";

			for (var k = 0; k < row.cells.length; k++) {
				//每一列
				var cell = row.cells[k];
				var td = tr.insertCell();

				td.innerHTML = cell.value;
				td.style.width = cell.width + "px";
				td.style.height = cell.height + "px";
				for (var key in cell.style) {
					td.style[key] = cell.style[key];
				}
				if (cell.databind && cell.databind.id && cell.databind.id != "") {
					if (ditem[cell.databind.id]) {
						td.innerHTML = ditem[cell.databind.id];
						// 表格td内容换行
						if (td.innerHTML.includes("\n")) {
							td.innerHTML = td.innerHTML.replace(/\n/g, "<br>");
						}
					} else {
						td.innerHTML = "";
					}
				}
				if (i == 0) {
					height += cell.height;
				}
			}
		}
	}
	if (everyPageHadHead) {
		table.appendChild(tableThead);
		table.appendChild(tableTbody);
	}
	var tablehtml = table;
	console.log("创建的表格");
	console.log(table);
	return tablehtml;
}



// WEBPACK FOOTER //
// ./src/util/printUtil.js